import React, { useState } from 'react';
import '../styles/components/about.css';
import { perfilImage, perfilImage2 } from '../assets'; 
import { useLanguage } from '../contexts/LanguageContext';

const About: React.FC = () => {
  const { t } = useLanguage();
  const [expanded, setExpanded] = useState(false);

  const handleReadMoreClick = () => {
    setExpanded(!expanded);
  };

  return (
    <section className="about-section">
      <div className="header-container">
        <div className="title-container">
          <h1 className="section-title">{t.about.title}</h1>
        </div>
      </div>
      <div className="about-content">
        <div className="about-info">
          <p className="about-description">
            {t.about.paragraphs[0]}
          </p>
          {expanded && (
            <>
              <p className="about-description">
                {t.about.paragraphs[1]}
                <img src={perfilImage2} alt={t.about.imageAltOne} className="about-image about-image-left" />
                {t.about.paragraphs[2]}
              </p>
              <p className="about-description">
                {t.about.paragraphs[3]}
                <img src={perfilImage} alt={t.about.imageAltTwo} className="about-image about-image-right" />
                {t.about.paragraphs[4]}
                {t.about.paragraphs[5]}
              </p>
            </>
          )}
          <button className="read-more" onClick={handleReadMoreClick}>
            {expanded ? t.about.readLess : t.about.readMore}
          </button>
        </div>
      </div>
    </section>
  );
};

export default About;
